import {WhitelabelEvent} from "../../../../../common/ts/events/Events";

interface AddFreeTextValueEventPayload {
    inputElement?: HTMLInputElement;
    chipContainer: Element[];
}

export class AddFreeTextValueEvent implements WhitelabelEvent {
    type: string;
    static readonly TYPE: string = 'add-free-text-value';
    payload: AddFreeTextValueEventPayload;

    constructor(payload: AddFreeTextValueEventPayload) {
        this.type = AddFreeTextValueEvent.TYPE;
        this.payload = payload;
    }
}

interface ChipContainerUpdatedEventPayload {
    containerElement: Element;
}

export class ChipContainerUpdatedEvent implements WhitelabelEvent {
    type: string;
    static readonly TYPE: string = 'chip-container-updated';
    payload: ChipContainerUpdatedEventPayload;

    constructor(payload: ChipContainerUpdatedEventPayload) {
        this.type = ChipContainerUpdatedEvent.TYPE;
        this.payload = payload;
    }
}

export class ChipCloseEvent implements WhitelabelEvent {
    type: string;
    static readonly TYPE: string = 'chip-closed';
    payload: ChipCloseEventPayload;

    constructor(payload: ChipCloseEventPayload) {
        this.type = ChipCloseEvent.TYPE;
        this.payload = payload;
    }
}

interface ChipCloseEventPayload {
    containerElement: Element;
    chip: HTMLElement;
}